import React from 'react';
import { FactorCards } from 'components/Fragments/FactorCards/FactorCards';
import 'partial/OfferManager/modules/NegativeMarks/NegativeMarksView.scss';
import SectionContainer from 'components/Containers/SectionContainer';
import { PageContainer } from 'components/Containers/PageContainer/PageContainer';
import StaticOfferContainer from 'partial/OfferManager/StaticOfferContainer';
import Label from 'components/form/Label/Label';
import { TitleContainer } from 'components/Containers/TitleContainer/TitleContainer';
import { Row } from 'components/Containers/Row/Row';
import { NEGATIVE_MARKS } from 'partial/OfferManager/module.constants';
import { NEGATIVE_MARKS_ACTION } from 'types/morph.pagePosition.constants';
import TextFromConfig from 'components/TextFromConfig';

function NegativeMarksView(props) {
  const negativeMarks =
    props.creditInfo.creditScoreAnalysis.paymentHistory.negativeRemarkAccounts
      .length + props.creditInfo.publicRecordsCount;
  const phGrade = props.creditInfo.creditScoreAnalysis.paymentHistory.grade;
  const defaultTestId = 'NegativeMarksView';

  return (
    <>
      {props.seenPixel}
      <PageContainer datatestid={defaultTestId} className="NegativeMarksView">
        <SectionContainer datatestid={defaultTestId}>
          <Row datatestid={defaultTestId} className="headerSimulationSection">
            <div className="header-container">
              <TitleContainer
                datatestid={`${defaultTestId}-container`}
                className="negativeMarksTitle"
              >
                <Label
                  type="H3"
                  typeHeader={'h3'}
                  datatestid={`${defaultTestId}-title-label`}
                >
                  <TextFromConfig
                    path={TextFromConfig.paths.NEGATIVE_MARKS_HEADER}
                  />
                </Label>
              </TitleContainer>
              <Label
                type="Body-1 m-text-14"
                datatestid={`${defaultTestId}-subHeader`}
              >
                <TextFromConfig
                  path={TextFromConfig.paths.NEGATIVE_MARKS_PARAGRAPH}
                />
              </Label>
            </div>
            <div
              className="factorSimSection"
              data-testid={`${defaultTestId}-factorSimSection`}
            >
              <FactorCards
                datatestid={defaultTestId}
                grade={phGrade}
                factorTitle={
                  negativeMarks === 1
                    ? `${negativeMarks} neg mark`
                    : `${negativeMarks} neg marks`
                }
                factorDescription={'PAYMENT HISTORY'}
                factorImpact={'HIGH IMPACT'}
              />
            </div>
          </Row>
          <Row datatestid={`${defaultTestId}-offers`}>
            <StaticOfferContainer
              module={NEGATIVE_MARKS}
              offerMetadataList={props.offer}
              eventHandler={props.eventHandler}
              pagePosition={NEGATIVE_MARKS_ACTION}
              modulePosition={props.modulePosition}
            />
          </Row>
        </SectionContainer>
      </PageContainer>
    </>
  );
}

export default NegativeMarksView;
